<template>
  <div class="sold-out-container">
    <div class="sold-out">
			<div class="sold-out-content">
				<img src="../../assets/common/sold-out.png">
				来晚啦，该内容已下架
			</div>
			<img class="sold-out-button" src="../../assets/common/sold-out-download.png">
		</div>
  </div>
</template>

<script>
export default {
  name: 'SoldOut'
}
</script>

<style lang="scss" scoped>
  .sold-out-container {
    /* 下架展示 */
    .sold-out {
      display: none;
    	position: fixed;
    	top: 0;
    	bottom: 0;
    	left: 0;
    	right: 0;
    	z-index: 999;
    	background-color: #fff;
      overflow-y: hidden;
    }

    .sold-out-content {
      position: absolute;
      top: 25%;
      left: 20%;
      right: 20%;
      text-align: center;
      color: #666666;
    }

    .sold-out-content img {
      margin-bottom: .3rem;
      width: 100%;
      height: auto;
    }

    .sold-out-button {
      position: absolute;
      bottom: 1rem;
    	width: 90%;
      left: 5%;
    	height: auto;
    }
  }
</style>
